var map = {
	"./Q1 option 1_48kHz.mp3": "./src/assets/sounds/Q1 option 1_48kHz.mp3",
	"./Q1 option 2_48kHz.mp3": "./src/assets/sounds/Q1 option 2_48kHz.mp3",
	"./Q1 option 3_48kHz.mp3": "./src/assets/sounds/Q1 option 3_48kHz.mp3",
	"./Q2 option 1_48kHz.mp3": "./src/assets/sounds/Q2 option 1_48kHz.mp3",
	"./Q2 option 2_48kHz.mp3": "./src/assets/sounds/Q2 option 2_48kHz.mp3",
	"./Q25_48kHz.mp3": "./src/assets/sounds/Q25_48kHz.mp3",
	"./Q26_48kHz.mp3": "./src/assets/sounds/Q26_48kHz.mp3",
	"./Q27_48kHz.mp3": "./src/assets/sounds/Q27_48kHz.mp3",
	"./Q29-32_48kHz.mp3": "./src/assets/sounds/Q29-32_48kHz.mp3",
	"./Q3 option 1_48kHz.mp3": "./src/assets/sounds/Q3 option 1_48kHz.mp3",
	"./Q3 option 2_48kHz.mp3": "./src/assets/sounds/Q3 option 2_48kHz.mp3",
	"./Q3 option 3_48kHz.mp3": "./src/assets/sounds/Q3 option 3_48kHz.mp3",
	"./Q3 option 4_48kHz.mp3": "./src/assets/sounds/Q3 option 4_48kHz.mp3",
	"./Q4 option 1_48kHz.mp3": "./src/assets/sounds/Q4 option 1_48kHz.mp3",
	"./Q4 option 2_48kHz.mp3": "./src/assets/sounds/Q4 option 2_48kHz.mp3",
	"./Q5 option 1_48kHz.mp3": "./src/assets/sounds/Q5 option 1_48kHz.mp3",
	"./Q5 option 2_48kHz.mp3": "./src/assets/sounds/Q5 option 2_48kHz.mp3",
	"./Q5 option 3_48kHz.mp3": "./src/assets/sounds/Q5 option 3_48kHz.mp3",
	"./Q6 option 1_48kHz.mp3": "./src/assets/sounds/Q6 option 1_48kHz.mp3",
	"./Q6 option 2_48kHz.mp3": "./src/assets/sounds/Q6 option 2_48kHz.mp3",
	"./Q6 option 3_48kHz.mp3": "./src/assets/sounds/Q6 option 3_48kHz.mp3",
	"./Q7 option 1_48kHz.mp3": "./src/assets/sounds/Q7 option 1_48kHz.mp3",
	"./Q7 option 2_48kHz.mp3": "./src/assets/sounds/Q7 option 2_48kHz.mp3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/sounds sync recursive ^\\.\\/.*$";